module.exports = __webpack_public_path__ + "static/media/arr.d75c2fd0.png";